import gsap from 'gsap';
import $ from '../core/Dom';

const init = () => {
    $('a').on('click', e => {
        const { hash } = e.triggerTarget;
        if (hash) {
            const target = $(`${hash}[data-anchor]`);
            if (target.length) {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: target.position().top, autoKill: false }, ease: 'power2.inOut', onComplete: () => { target.get(0).focus(); } });
            }
        }
    });
};

export default {
    init
};
